"use client"

import { ScopeProvider } from "bunshi/react"
import { NftsToBuyScope, type PurchasableNft } from "./scope"

interface Props {
  children: React.ReactNode
}

const initialState: PurchasableNft[] = []

export function NftsToBuyScopeProvider({ children }: Props) {
  return (
    <ScopeProvider scope={NftsToBuyScope} value={initialState}>
      {children}
    </ScopeProvider>
  )
}
